export const parseYoutubeId = (url: string) => {
  const re =
    /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/ ]{11})/i;
  return url.match(re)?.[1] || null;
};
